import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../lib/api";

function formatDate(value) {
  if (!value) return "Recently";
  try {
    return new Date(value).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "Recently";
  }
}

export default function NoticeDetail() {
  const { slug } = useParams();
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    api(`/api/notices/${slug}`)
      .then(setNotice)
      .catch((err) => setError(err.message || "Notice not found"))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <main className="min-h-screen bg-slate-50 px-4 py-16"><div className="mx-auto max-w-4xl rounded-3xl bg-white p-8 font-bold text-slate-600 shadow-sm">Loading notice...</div></main>;
  }

  if (error || !notice) {
    return (
      <main className="min-h-screen bg-slate-50 px-4 py-16">
        <section className="mx-auto max-w-4xl rounded-3xl bg-white p-8 shadow-sm">
          <p className="font-bold text-red-700">{error || "Notice not found."}</p>
          <Link to="/notice-board" className="mt-5 inline-flex rounded-xl bg-emerald-700 px-4 py-2 text-sm font-bold text-white">Back to Notice Board</Link>
        </section>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-16">
      <article className="mx-auto max-w-4xl rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200 md:p-10">
        <Link to="/notice-board" className="text-sm font-black text-emerald-700 hover:text-emerald-800">← Back to Notice Board</Link>

        <div className="mt-6 flex flex-wrap gap-2">
          <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-black text-emerald-700">{notice.category}</span>
          <span className={`rounded-full px-3 py-1 text-xs font-black ${notice.priority === "urgent" ? "bg-red-100 text-red-700" : notice.priority === "important" ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-700"}`}>{notice.priority}</span>
          <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-black text-blue-700">{notice.target_audience}</span>
        </div>

        <h1 className="mt-5 text-3xl font-black leading-tight text-slate-950 md:text-5xl">{notice.title}</h1>
        <p className="mt-4 text-sm font-semibold text-slate-500">Published {formatDate(notice.published_at || notice.created_at)}</p>

        <div className="mt-8 whitespace-pre-line text-base leading-8 text-slate-700 md:text-lg">
          {notice.body}
        </div>
      </article>
    </main>
  );
}
